import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-app_icon-25",
  "use": "icon-app_icon-25-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"icon-app_icon-25\"><g><path d=\"M18 3c6.075 0 11 4.857 11 10.85a10.687 10.687 0 01-1.877 6.062l-.204.29-.005-.001L18.081 31 9.11 20.23a8.19 8.19 0 01-.416-.595l-.19-.309A10.687 10.687 0 017 13.85C7 7.857 11.925 3 18 3zm0 6a5 5 0 100 10 5 5 0 000-10z\" /><ellipse fill-opacity=\".6\" cx=\"18\" cy=\"31\" rx=\"15\" ry=\"3\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol